import { render, staticRenderFns } from "./ReportLogs.vue?vue&type=template&id=497a2bed&"
import script from "./ReportLogs.vue?vue&type=script&lang=js&"
export * from "./ReportLogs.vue?vue&type=script&lang=js&"
import style0 from "./ReportLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports